class DZModelWikiSearch {
    /**
     * 百科类型
     */
    type = "";

    /**
     * 百科标题
     */
    title = "";

    /**
     * 当前页码
     */
    pageNum = 1;

    /**
     * 每页数量
     */
    pageSize = 10;


    total = 0;

}
export default DZModelWikiSearch;
